export default "__VITE_ASSET__BhbvkX5P__"